<div class="submit-review" data-testid="submit-review-dialog">
  <div class="submit-review__header">
    <h2 class="submit-review__title">{{ 'translations.v3Forms.submitReview.title' | transloco }}</h2>
    <p class="submit-review__subtitle">{{ 'translations.v3Forms.submitReview.subtitle' | transloco }}</p>
  </div>

  <div class="submit-review__body">
    <div class="submit-review__what-happens">
      <span class="submit-review__what-happens-title">{{ 'translations.v3Forms.submitReview.whatHappensTitle' | transloco }}</span>
      <ul class="submit-review__list">
        <li>{{ 'translations.v3Forms.submitReview.whatHappens1' | transloco }}</li>
        <li>{{ 'translations.v3Forms.submitReview.whatHappens2' | transloco }}</li>
        <li>{{ 'translations.v3Forms.submitReview.whatHappens3' | transloco }}</li>
      </ul>
    </div>

    @if (showReviewerSelect) {
      <div class="submit-review__field">
        <span class="submit-review__label">{{ 'translations.v3Forms.submitReview.reviewerLabel' | transloco }}</span>
        <span class="submit-review__sublabel">{{ 'translations.v3Forms.submitReview.reviewerSublabel' | transloco }}</span>
        <ptl-autocomplete-search
          [multiSelect]="true"
          [serverSide]="true"
          [options]="reviewerOptions()"
          [ngModel]="selectedReviewerUids()"
          (selectionChange)="onReviewersChange($event)"
          (searchTermChange)="onReviewerSearch($event)"
        ></ptl-autocomplete-search>
      </div>
    }

    <div class="submit-review__field">
      <span class="submit-review__label">{{ 'translations.v3Forms.submitReview.noteLabel' | transloco }}</span>
      <textarea class="submit-review__note" rows="4" [value]="note()" (input)="onNoteChange($any($event.target).value)"></textarea>
    </div>
  </div>

  <div class="submit-review__footer">
    <ptl-button type="secondary" size="s" [text]="'translations.global.button.cancel' | transloco" (clicked)="cancel()"></ptl-button>
    <ptl-button
      data-testid="submit-review-confirm"
      type="primary"
      size="s"
      [text]="'translations.v3Forms.submitReview.submit' | transloco"
      [disabled]="!canSubmit()"
      (clicked)="submit()"
    ></ptl-button>
  </div>
</div>
